import { isString } from 'ionic-angular/util/util';
import { Field } from '../field/field.model';
import { VersionedObject } from '../versioned-object';

export const shouldUpdate = (newObject: VersionedObject, oldObject: VersionedObject): boolean => {

    if (newObject.version < oldObject.version) {
        // we are receiving (from api) an old version of this object
        return false;
    } else if (newObject.version === oldObject.version) {
        // we are receiving (from local) an update to the current version
        return true;
    }
    // we are receiving (from api) an update, but we don't want to overwrite our local changes
    return !oldObject.dirty;
};

export const handleFieldValue = (field: Field, extend = {}): Field => {

    if (isString(field.value) && (field.value[0] === '{' || field.value[0] === '[')) {
        return new Field({
            ...field,
            ...extend,
            value: JSON.parse(field.value)
        });
    }
    return new Field({...field, ...extend});
};
export const handleFields = (newFields: Array<Field>, oldFieldMap: Map<string, Field>): Array<Field> => {
    return newFields
        .map(fNew => {
            const fOld = oldFieldMap.get(fNew.id);

            if (!fOld) {
                return handleFieldValue(fNew);
            }

            if (!shouldUpdate(fNew, fOld)) {
                return fOld;
            }

            return handleFieldValue(fNew);
        });
};



// WEBPACK FOOTER //
// ./src/vas/business-objects/job/job.reducer.helpers.ts